module.exports = __webpack_public_path__ + "img/20190611_113036_009.34020e3b.jpg";